/* Variante B — CRO Test JS */
(function(){
  "use strict";
  if(window.__VB_INIT) return; /* Doppel-Initialisierung verhindern (Script kann von Hero UND Sticky geladen werden) */
  window.__VB_INIT = true;

  /* ---------- Zentraler Sale-Timer (Quelle: Header-Countdown / VB Hero) ---------- */
  function nextEnd(){
    var now = new Date();
    var best = null;
    (window.VB_SALE_ENDS || '').split('\n').forEach(function(line){
      var m = line.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/);
      if(!m) return;
      var d = new Date(+m[1], +m[2]-1, +m[3], +m[4], +m[5], 59);
      if(d > now && (!best || d < best)) best = d;
    });
    if(best) return best;
    if(window.VB_SALE_WEEKLY === false) return null;
    var end = new Date(now);
    end.setDate(now.getDate() + ((7 - now.getDay()) % 7));
    end.setHours(23,59,59,0);
    return end;
  }
  function cdText(s){
    var d = Math.floor(s/86400), h = Math.floor(s%86400/3600), m = Math.floor(s%3600/60), sec = s%60;
    if(d >= 1) return d + (d === 1 ? ' Tag ' : ' Tagen ') + h + ' Std. ' + m + ' Min.';
    if(h >= 1) return h + ' Std. ' + m + ' Min. ' + sec + ' Sek.';
    return m + ' Min. ' + sec + ' Sek.';
  }
  function tick(){
    var end = nextEnd();
    if(!end){
      document.querySelectorAll('.vb-salechip, .vb-enddate').forEach(function(e){ e.style.display = 'none'; });
      return;
    }
    var s = Math.max(0, Math.floor((end - new Date())/1000));
    var txt = cdText(s);
    document.querySelectorAll('.vb .cd, .rl .cd').forEach(function(e){ e.textContent = txt; });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- Preis-Formatierung (Rappen → CHF) ---------- */
  function fmt(cents){
    var n = Math.round(cents/100);
    return "CHF " + n.toLocaleString('de-CH').replace(/,/g, "'");
  }

  /* ---------- Buy-Block: Variantenwechsel ---------- */
  var sel = document.getElementById('vb-size');
  function upd(){
    if(!sel) return;
    var o = sel.options[sel.selectedIndex];
    var price = parseInt(o.getAttribute('data-price'), 10);
    var cmp = parseInt(o.getAttribute('data-compare') || '0', 10);
    var elNow = document.getElementById('vb-pnow');
    var elWas = document.getElementById('vb-pwas');
    var elSave = document.getElementById('vb-psave');
    var elMonth = document.getElementById('vb-pmonth');
    var elSticky = document.getElementById('vb-stickyprice');
    if(elNow) elNow.textContent = fmt(price);
    if(elWas){ elWas.textContent = cmp > price ? fmt(cmp) : ''; elWas.style.display = cmp > price ? '' : 'none'; }
    if(elSave){
      if(cmp > price){ elSave.textContent = "Spare " + Math.round((1 - price/cmp)*100) + "%"; elSave.style.display=''; }
      else elSave.style.display='none';
    }
    if(elMonth) elMonth.textContent = fmt(price/12) + "/Mt.";
    if(elSticky) elSticky.textContent = "ab " + fmt(price);
  }
  if(sel){ sel.addEventListener('change', upd); upd(); }

  /* ---------- Zusatzprodukt (Mitnahme) ---------- */
  var buyForm = document.getElementById('vb-buy-form');
  if(buyForm){
    buyForm.addEventListener('submit', function(e){
      var addon = document.getElementById('vb-addon');
      if(!addon || !addon.checked) return;
      e.preventDefault();
      var items = [
        { id: parseInt(sel.value, 10), quantity: 1 },
        { id: parseInt(addon.getAttribute('data-variant'), 10), quantity: 1 }
      ];
      var btn = buyForm.querySelector('button[type="submit"]');
      if(btn){ btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){
        if(!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function(){
        if(btn){ btn.disabled = false; }
        buyForm.submit();
      });
    });
  }

  /* ---------- Pain-Cards → Accordion ---------- */
  window.vbOpenTech = function(id){
    document.querySelectorAll('.vb-tech details.vb-acc').forEach(function(d){ d.removeAttribute('open'); });
    var el = document.getElementById(id);
    if(el) el.setAttribute('open','');
  };

  /* ---------- Review-Tabs ---------- */
  window.vbShowRev = function(key, btn){
    document.querySelectorAll('.vb-reviews .vb-tab').forEach(function(t){ t.classList.remove('on'); });
    if(btn) btn.classList.add('on');
    document.querySelectorAll('.vb-reviews .vb-rev').forEach(function(r){
      r.hidden = (r.getAttribute('data-cat') !== key);
    });
  };
  function initTabs(){
    var firstTab = document.querySelector('.vb-reviews .vb-tab');
    if(firstTab) window.vbShowRev(firstTab.getAttribute('data-cat'), firstTab);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initTabs); } else { initTabs(); }

  /* ---------- Schlaf-Check (6 Fragen) ---------- */
  var qa = {}, qc = 0, QT = 7;
  function el(id){ return document.getElementById(id); }
  window.vbQzOpen = function(){ var o = el('vb-qzo'); if(o) o.classList.add('open'); };
  window.vbQzClose = function(){ var o = el('vb-qzo'); if(o) o.classList.remove('open'); };
  window.vbQgo = function(n){
    var cur = el('vb-q'+qc), nxt = el('vb-q'+n);
    if(cur) cur.classList.remove('active');
    if(nxt) nxt.classList.add('active');
    qc = n;
    var bar = el('vb-qbar');
    if(bar) bar.style.width = Math.round(n/QT*100)+'%';
    if(n === 7) qrender();
  };
  window.vbQp = function(k,v){ qa[k]=v; window.vbQgo(qc+1); };

  function qrender(){
    var h = el('vb-qr-h'), title = el('vb-qr-title'), why = el('vb-qr-why'),
        quote = el('vb-qr-quote'), cta = el('vb-qr-cta'), alt = el('vb-qr-alt');
    if(!h) return;
    quote.style.display = ''; cta.style.display = ''; alt.style.display = 'none';

    var dq = null;
    if(qa.weight === 'o150') dq = 'heavy';
    else if(qa.weight === 'u50') dq = 'light';
    else if(qa.budget === 'u500') dq = 'budget';

    if(dq === 'heavy'){
      h.textContent = 'Ehrliche Antwort: Die Ultra ist hier nicht die richtige Wahl.';
      title.textContent = 'Unsere ehrliche Einschätzung';
      why.innerHTML = 'Die Ora Ultra ist bis <b>150 kg pro Person</b> ausgelegt. Darüber können wir dir den erholsamen Schlaf nicht ehrlich versprechen — und das sagen wir dir lieber jetzt als nach dem Kauf. Melde dich bei uns: Wir beraten dich offen, ob es eine passende Lösung gibt.';
      quote.style.display = 'none'; cta.style.display = 'none'; alt.style.display = '';
      return;
    }
    if(dq === 'light'){
      h.textContent = 'Ehrliche Antwort: Da schauen wir besser gemeinsam hin.';
      title.textContent = 'Unsere ehrliche Einschätzung';
      why.innerHTML = 'Unter <b>50 kg</b> ist die Ultra für dich vermutlich zu fest: Die Schulter- und Beckenzonen brauchen etwas Körpergewicht, um richtig einzusinken. Lass dich kurz von uns beraten — ehrlich und unverbindlich. Falls du es trotzdem probieren willst: Dafür gibt es die 200 Nächte.';
      quote.style.display = 'none'; cta.textContent = 'Trotzdem ansehen — 200 Nächte Rückgaberecht →'; alt.style.display = '';
      return;
    }
    if(dq === 'budget'){
      h.textContent = 'Ehrliche Antwort: Unter CHF 500 wird es schwierig.';
      title.textContent = 'Guter Schlaf als Investition';
      why.innerHTML = 'Die Ora Ultra gibt es ab CHF 889 — auch im Sale nicht darunter, das wäre nicht ehrlich. Aber rechne einmal anders: Eine Matratze begleitet dich rund 10 Jahre. Das sind etwa <b>25 Rappen pro Nacht</b> für den Schlaf, der über deine Energie am Tag entscheidet. Mit <b>0%-Ratenzahlung via Heylight ab ca. CHF 74/Monat</b> — und 200 Nächten Rückgaberecht, falls sie ihr Geld nicht wert ist.';
      quote.style.display = 'none'; cta.textContent = 'Mit 0%-Raten ansehen →'; alt.style.display = '';
      return;
    }

    h.textContent = 'Die Ora Ultra passt sehr gut zu dir.';
    title.textContent = 'Ora Ultra';
    cta.textContent = 'Meine Empfehlung ansehen →';
    var why_ = '';
    if(qa.pain === 'Nacken/Schulter') why_ = 'Als <b>'+qa.pos+'</b> mit <b>Nacken-/Schulterverspannungen</b> ist die ViscoAir-Schulterzone für dich entscheidend: Die Schulter sinkt tiefer ein, die Wirbelsäule bleibt gerade.';
    else if(qa.pain === 'Rücken') why_ = 'Als <b>'+qa.pos+'</b> mit <b>Schmerzen im unteren Rücken</b> profitierst du von der 7-Zonen-Stützung: Becken und Lendenwirbel hängen nicht mehr durch. 83% unserer befragten Kunden berichten von einer Verbesserung — die Hälfte innert 7 Tagen.';
    else if(qa.pain === 'Hüfte') why_ = 'Bei <b>Hüftschmerzen</b> zählt Druckentlastung: Der adaptive Schaum verteilt den Druck, statt ihn auf die Hüfte zu konzentrieren.';
    else why_ = 'Keine akuten Schmerzen — perfekt. Bei dir geht es um <b>Schlafqualität</b>: schneller einschlafen, tiefer durchschlafen.';
    if(qa.weight === '90-150') why_ += ' Mit deinem Gewicht profitierst du besonders von der hohen Stützkraft des 7-Zonen-Kerns.';
    if(qa.heat === 'Ja') why_ += ' Gegen dein nächtliches Schwitzen arbeitet die <b>Oceans-Cool-Schicht</b> — 71% schlafen damit kühler als vorher.';
    if(qa.partner === 'Zu zweit') why_ += ' Der <b>Zero-Motion-Transfer</b> sorgt dafür, dass du die Bewegungen deines Partners kaum noch spürst.';
    why_ += ' Und falls sie doch nicht passt: <b>200 Nächte Rückgaberecht.</b> Deine Grösse wählst du gleich im nächsten Schritt.';
    why.innerHTML = why_;
    var q = '«Keine Verspannungen mehr im Nacken- und Kreuzbereich – und mehr Energie morgens.»';
    if(qa.pain === 'Rücken') q = '«Keine Rückenschmerzen mehr. Die Matratze hält, was sie verspricht.»';
    if(qa.partner === 'Zu zweit') q = '«Zu zweit merkt man nichts von seinem Bettnachbar, wenn er sich bewegt.»';
    quote.innerHTML = q + '<span>Verifizierte Kundenbewertung</span>';
  }
})();
